// eslint-disable-next-line no-restricted-imports
import { DirectGoalCostType } from '../../../../../data-layer/direct/types';
import type { DropdownOption } from '../ContentPromotionDropdown/types';

export const costTypeOptions: DropdownOption[] = [
    { value: DirectGoalCostType.DYNAMIC, label: 'Динамическая' },
    { value: DirectGoalCostType.MANUAL, label: 'Задать в ручную' },
];
